const R = 30, CX = 50, CY = 52.5;
const PTS = Array.from({ length: 10 }, (_, i) => {
  const a = -Math.PI / 2 + (i * Math.PI) / 5, r = i % 2 ? R * 0.382 : R;
  return [+(CX + r * Math.cos(a)).toFixed(2), +(CY + r * Math.sin(a)).toFixed(2)];
});
const OUTLINE = `M${PTS.map((p) => p.join(" ")).join(" L")} Z`;

export function StarLogo({ className = "h-6 w-6" }) {
  return (
    <svg viewBox="0 0 100 100" className={className} aria-hidden="true" data-testid="star-logo-icon">
      <rect x="3" y="3" width="94" height="94" rx="20" fill="#ffffff" stroke="#000000" strokeWidth="3" />
      <path d={OUTLINE} fill="#000000" />
    </svg>
  );
}
